import React from "react";
import { mergeStyleSets, Spinner } from "@fluentui/react";
import { useStore } from "@/utilities/storeHook";
import { useTranslation } from "react-i18next";
interface IBZASpinner {
  loading: boolean;
  label?: string;
  style?: any
}
export const spinnerStyle = mergeStyleSets({
  spinner: {
    width: "100%",
    background: "rgba(0, 0, 0, 0.1)",
    position: "absolute",
    zIndex: 9999,
    pointerEvents: "auto"
  }
});

const BZASpinner = ({ loading = true, label, style }: IBZASpinner) => {
  const { t } = useTranslation();
  const defaultLabel = label || t("loading");
  const { commonStore, errorStore } = useStore();
  const { showMessageBar } = commonStore;
  return (
    <>
      {loading
        ? <Spinner label={defaultLabel} style={style
          ? { ...style }
          : { height: `calc(100vh - ${showMessageBar && errorStore.errormessage !== "" ? 97 : 60}px)` }}
          className={spinnerStyle.spinner} />
        : null}
    </>
  );
};

export default BZASpinner;
